export const supportLinks = {
  highlightsTechSupportInquiryForm: 'https://earlylearning.highlights.com/pages/contact-us',
  zbportalTechSupportInquiryForm: 'https://www.zaner-bloser.com/contact/tech-support',
  qrCodeLoginHelpVideo: 'https://zanerbloser.wistia.com/medias/h6py4c2ae5'
} as const;
